import { FormControl } from "@angular/forms";
import { CommonService } from "src/app/service/common.service";
import { ExpiryItemDateDto, ExpiryItemDto, UpdateExpiryAlertDto } from "src/app/webservice/item-expiry";
import { OrderGroupDto } from "src/app/webservice/order-group";
import { ExpiryItemRec } from "./expiry-item-rec";
import { HttpBasicService } from "src/app/service/http-basic.service";

export interface ExpiryAlertDesc {
  alertType:          number;
  itemDate:           string;
  alertRank:          number;
  alertStartDate:     string;
  alertMsg:           string;
  isSoldOut:          boolean;
  isCompleted:        boolean;
  isCompletedAll:     boolean[];
  alertStartDates:    Date[];
  edit?: {
    isDirty:          boolean;
    formStatus:       FormControl;
    formPrintCount:   FormControl;
  }
}

export class ExpiryAlertRec extends ExpiryItemRec {

  public alertDescs:  ExpiryAlertDesc[] = [];
  public itemGroups:  OrderGroupDto[];

  private expiryItemDto: ExpiryItemDto;
  private orderGroupDto: OrderGroupDto[];
  private expiryItemDateDtoList: ExpiryItemDateDto[] = [];

  constructor(
    public commonService: CommonService,
    public httpBasic: HttpBasicService) {

    super(commonService, httpBasic);
  }

  initExpiryItemDto(dto: ExpiryItemDto) {
    this.expiryItemDto = dto;
  }

  initOrderGroupDto(dto: OrderGroupDto[]) {
    this.orderGroupDto = dto;
  }

  addExpiryItemDateDto(dto: ExpiryItemDateDto) {
    this.expiryItemDateDtoList.push(dto);
  }

  initComplete(orderGroupUsrCd: string) {
    super.initByDto(this.expiryItemDto, this.orderGroupDto, this.expiryItemDateDtoList, orderGroupUsrCd);
  }

  prepareEdit() {
    super.prepareEdit();
  }

  setChangeListener(func: (mode: boolean)=>void) {
    this.changeListener = func;
    super.setListner(func);
  }

  getSaveData(): UpdateExpiryAlertDto[] {
    let dtos: UpdateExpiryAlertDto[] = [];

    return dtos;
  }

  commitEdit() {
    super.commitEdit();
  }

  getStatus(desc: ExpiryAlertDesc) {
    let formVal = parseInt(desc.edit?.formStatus.value);
    if (formVal === 0) {
      return {
        isCompleted: false,
        isSoldOutDate: false,
        isSoldOutItem: false
      };
    } else if (formVal === 1) {
      return {
        isCompleted: true,
        isSoldOutDate: false,
        isSoldOutItem: false
      };
    } else if (formVal === 2) {
      return {
        isCompleted: true,
        isSoldOutDate: true,
        isSoldOutItem: false
      };
    } else if (formVal === 3) {
      return {
        isCompleted: true,
        isSoldOutDate: true,
        isSoldOutItem: true
      }
    };
    return {
      isCompleted: false,
      isSoldOutDate: false,
      isSoldOutItem: false
    };
  }

  endEdit() {
    super.cleanupEdit();
    this.cleanupEdit();
  }

  clearEdit() {
    super.cancelEdit();

    this.cleanupEdit();
    this.prepareEdit();
  }

  cleanupEdit() {
    super.cleanupEdit();

    this.subsc.forEach((subsc) => {subsc.unsubscribe();});
    this.subsc = [];
    this.alertDescs.forEach((desc) => { if (desc.edit) delete desc.edit; });
  }

  dirty() {
    if (super.dirty()) return true;
    for (let i = 0; i < this.alertDescs.length; i++) {
      if (this.alertDescs[i].edit?.isDirty) return true;
    }
    return false;
  }

  getValue(desc: ExpiryAlertDesc, key: string) {
    switch(key) {
      case "expiryDate": {
        if (desc.alertType === -1) return "";
        if (desc.alertType === 2) return "";
        if (this.expiryType === 2) return "";
        return desc.itemDate;
      }
      case "productionDate": {
        if (desc.alertType === -1) return "";
        if (desc.alertType === 2) return "";
        if (this.expiryType === 1) return "";
        return desc.itemDate;
      }
      case "alertMsg": {
        return desc.alertMsg;
      }
      case "alertStartDate": {
        return desc.alertStartDate;
      }
      default:
        return "";
    }
  }

  getColor(desc) {
    let white = {"color": "black", "background-color": "white"};
    let red = {"color": "#FF0000", "background-color": "#FBE5D6", "font-weight": "bold"};

    if (desc.alertType === 2) return white;
    let rank = desc.alertRank - 1;
    if (rank < 0) return red;
    if (rank > 4) return red;
    return {
      "color": this.commonService.config.itemExpiry.colors[rank].fg,
      "background-color": this.commonService.config.itemExpiry.colors[rank].bg,
      "font-weight": "bold"
    };
  }

  hasItemDateAlert() {
    for (let i = 0; i < this.alertDescs.length; i++) {
      if (this.alertDescs[i].alertType === 1) return true;
    }
    return false;
  }
}
